export default __webpack_public_path__ + "static/Instagram-75e0546a6b5abe4c05063c93871ac0a8.png";